<template>
<transition name="modal">
	<div class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container-wrapper">
			<div class="modal-container">
				<div class="modal-window-tab-mark">
				</div>
				<div class="modal-close-button" @click="$emit('close')"><img src="images/x.png" class="fillImg" /></div>
				<div class="modal-wndow-content">
					<div class="modal-wndow-content-title">
						<h3>צרו איתי קשר</h3></div>
					<div class="login-state">
						<div class="login-state-tab stateActive">השארת פרטים</div>
					</div>
					<div class="login-info" v-if="loginState == 1">
						<p>פרטיך נרשמו, נפנה אליך בהקדם</p>
						<p>תודה</p>
						<label class="login-next-button"
										@click="$emit('close')">סגור</label>
					</div>
					<div class="login-info" v-if="loginState == 0">
						<div class="login-input-line errorMessage" >
							{{validationMessage}}
						</div>
						<div id="selectLine" class="login-input-line">
							<div class="login-select">
								<select option v-on:keyup.enter="focusNext(1)" id="TalkToMeBranchSelect"
													v-model:value="branchInput"
													onfocus="this.style.background-color='#000000';this.style.color='#c7b7a5';this.style.color='#c7b7a5';this.size=10;this.oldHeight=this.style.height;this.style.height='150px'"
													onblur='this.style.background-color="#000000";this.style.color="#FF632B";this.size=1;this.style.height=this.oldHeight'
													onchange='this.style.background-color="#000000";this.size=1; this.blur();'>
									<option>סניף</option>
									<option>מרכז (תל אביב)</option>
									<option>צפון (חיפה)</option>
								</select>
							</div>
							<div class="login-content-info">אנא בחר את הסניף אליו תהייה מעוניין להרשם</div>
						</div>
						<div class="login-input-line">
							<input class="login-input" autocomplete="off" v-on:keyup.enter="focusNext(2)" placeholder="שם פרטי ושם משפחה" @focus="onNameInput($event.target.value)" v-bind:value="nameInput" id="nameInputID" @input="onNameInput($event.target.value)" />
						</div>
						<div id="selectLine" class="login-input-line">
							<div class="login-select">
								<select option v-on:keyup.enter="focusNext(3)" v-if="auditionType == 'Rhythm'" id="TalkToMeinstrumentSelect"
													v-model:value="instrumentInput"
													onfocus="this.style.background-color='#000000';this.style.color='#c7b7a5';this.style.color='#c7b7a5';this.size=10;this.oldHeight=this.style.height;this.style.height='150px'"
													onblur='this.style.background-color="#000000";this.style.color="#FF632B";this.size=1;this.style.height=this.oldHeight'
													onchange='this.style.background-color="#000000";this.size=1; this.blur();'>
									<option>כלי נגינה ראשי</option>
									<option>גיטרה חשמלית</option>
									<option>גיטרה אקוסטית</option>
									<option>בס</option>
									<option>קלידים</option>
									<option>חליליות</option>
									<option>סקסופון אלט</option>
									<option>סקסופון טנור</option>
									<option>סקסופון בריטון</option>
									<option>סקסופון סופרן</option>
									<option>קלרינט</option>
									<option>מפוחית</option>
									<option>חליל צד</option>
									<option>חצוצרה</option>
													<option>טרומבון</option>
									<option>תופים</option>
									<option>כלי הקשה</option>
									<option>כלי פריטה אחרים</option>
									<option>כלי קשת</option>
									<option>שירה</option>
									<option>אני רב כלי</option>
								</select>
								<select style='color:"#FF632B";' v-on:keyup.enter="focusNext(3)"  v-if="auditionType == 'Ensemble'" id="TalkToMe"
													v-model:value="instrumentInput"
													onfocus="this.style.color='#c7b7a5'"
													onblur='this.style.color="#FF632B"'
													onchange='this.size=1; this.blur();'>
									<option>שירה</option>
								</select>
							</div>
							<div class="login-content-info">הכלי הראשי שלך. אם אתה מנגן על כמה כלים ולא בטוח לגבי זה בחר "אני רב כלי"</div>
						</div>
						<div class="login-input-line">
							<input class="login-input"
							v-on:keyup.enter="focusNext(4)"
							 id="emailInputID"
										autocomplete="off"
										placeholder="אימייל"
										v-bind:value="emailInput"
										 @input="onEmailInput($event.target.value)" />
							<div id="email-info" class="login-content-info">אנא וודא שהכתובת תקינה</div>
						</div>
						<div class="login-input-line">
						<input v-on:keyup.enter="focusNext(5)" dir="ltr" class="login-input" id="hphoneInputID"  autocomplete="off" placeholder="נייד" v-bind:value="phoneInput" @focus="onPhoneInput($event.target.value)" @input="onPhoneInput($event.target.value)" />
						</div>
									
					</div>
						<label class="login-next-button"
									v-on:click="registerUser()">שלח</label>
				</div>

				<div class="modal-footer"> <label class="modal-footer-title">או פשוט דברו איתנו:</label></br>
				<label class="modal-footer-text">
החצר צפון: <a href="tel:0507731726">050-7731726</a>
					 | <a href="mailto:NOFFICE@YARDBANDS.COM">NOFFICE@YARDBANDS.COM</a>
				</label>
					</br>
				<label class="modal-footer-text">
					החצר מרכז: <a href="tel:0547737094">054-7737094</a>
					 | <a href="mailto:OFFICE@YARDBANDS.COM">OFFICE@YARDBANDS.COM</a>
				</label>
				

				</div>
				<div class="modal-bottom-image"><img src="images/logo.png" class="fillImg" /></div>
			</div>
			</div>
		</div>
	</div>
</transition>
</template>

<script>
import axios from 'axios'
import VueScrollTo from 'vue-scrollto'
var APIbase = "https://yard-bands.herokuapp.com"
export default {
	components: {},
	props: ['auditionType'],
	created() {
		console.log(this.auditionType);
		if (this.auditionType == 'Ensemble') {
			this.instrumentInput = 'שירה'
		}
	},
	data() {
		return {
			branchInput : "סניף",
			nameInput : "",
			instrumentInput : "כלי נגינה ראשי",
			emailInput : "",
			phoneInput : "",
			validationMessage : "",
			loginState: 0,
			refreshId:0
		}
	},
	watch: {
		instrumentInput: function (val) {
			if (val === "כלי נגינה ראשי") {
				document.getElementById("TalkToMeinstrumentSelect").style.color = "#c7b7a5";
			}
			this.$forceUpdate();
		},
		branchInput: function (val) {
			if (val === "סניף") {
				document.getElementById("TalkToMeBranchSelect").style.color = "#c7b7a5";
			}
			this.$forceUpdate();
		}
	},
	methods: {
	focusNext(num) {
		if (num == 1) {
			document.getElementById("nameInputID").focus();
		}
		if (num == 2) {
			document.getElementById("TalkToMeinstrumentSelect").focus();
		}
		else if (num == 3) {
		 document.getElementById("emailInputID").focus();
		}
		else if (num == 4) {
		 document.getElementById("emailInputValID").focus();
		}
		else if (num == 5) {
		 document.getElementById("hphoneInputID").focus();
		}
		else {
			this.registerUser();
		}
	},
		registerUser(){
			this.validateInput()
			if (this.validationMessage === "") {
				var site = 'center';
				if (this.branchInput == 'צפון (חיפה)')
				{
					site = 'north';
				}
				axios.post(APIbase+'/v2/create_user_for_detailes',{
									'name':this.nameInput,
									'instrument':this.instrumentInput,
									'email':this.emailInput,
									'phone':this.phoneInput,
									'site': site,
									'audition_type':this.auditionType
								}).then(response => {
					this.loginState = 1
					if (site == 'center') {
						window.location.href = "https://yardbands.com/detailstelaviv";
					}
					else {
						window.location.href = "https://yardbands.com/detailshaifa";
					}
				});

			}
		},
		onEmailInput(val){
			var local_tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*/;
			var domain_tester = /[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
			
			var new_emailParts = val.split('@');

			if (new_emailParts.length < 2) {
				if ( (val.length==0 || local_tester.test(val)) && val.length <= 64) {
					this.emailInput = val;
				}
			}
			else if (new_emailParts.length == 2) {
				var old_emailParts = this.emailInput.split('@');
				var result = "";
				if ( (new_emailParts[0].length>0  && !local_tester.test(new_emailParts[0])) || new_emailParts[0].length > 64) {
					result = old_emailParts[0]; 
				}
				else {
					result = new_emailParts[0];
				}
				if ( new_emailParts[1] > 255) {
					if (old_emailParts.length <2 ) {
						result = result + "@";
					}
					else {
						result = result + "@" + old_emailParts[1].trim();
					}
				}
				else {
					result = result + "@" + new_emailParts[1].trim();
				}
				this.emailInput = result.trim();
			}
			this.$forceUpdate();
		},
		onEmailValInput(val){
			this.emailValInput = val
		},
		onNameInput(val){
			let forbiddenChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
			let result = Array.from(val).filter(f=> !forbiddenChars.includes(f)).join('');
			if (result.length < val.length) {
				this.validationMessage = "השארת פרטים בעברית בלבד"
			}else {
				this.validationMessage = ""
			}

			this.nameInput = result;
			this.$forceUpdate();
		},
		onPhoneInput(val){
			let allowedChars = "0123456789";
			let result = Array.from(val).filter(f=> allowedChars.includes(f)).join('');
			if (result.length > 10) {
				this.phoneInput = result.substring(0,10);
			}
			else if (result.length <= 2) {
				this.phoneInput = "05";
				this.$forceUpdate();
				window.setTimeout(function() {
					var InputElement = document.getElementById("hphoneInputID");
					InputElement.setSelectionRange(2, 2);
            	}, 1);
			}
			else if (!result.startsWith('05')) {
				var InputElement = document.getElementById("hphoneInputID");
				InputElement.setSelectionRange(this.phoneInput.length, this.phoneInput.length);
			}
			else {
				this.phoneInput = result;
			}
			this.$forceUpdate();

		},
		instrumentSelected(val){

		},
		validateEmail() {
			var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

				var emailParts = this.emailInput.split('@');

				if (emailParts.length !== 2) {
					return 1;
				}

				var account = emailParts[0];
  				var address = emailParts[1];

 				if (account.length > 64 || address.length > 255) {
					return 2;
				}
			        var domainParts = address.split('.');
  
			        if (domainParts.some(function (part) {
                                         return part.length > 63;
                                 })) {
					return 3;
				}
				if (!tester.test(this.emailInput)) {
					return 4;	
				}
				return 0;

		},
		validateInput() {
			var re = /\S+@\S+\.\S+/;
			if (this.nameInput === "") {
				this.validationMessage = "נא להקליד שם ושם משפחה"
			}
			else if (this.instrumentInput === "כלי נגינה"
			|| this.instrumentInput === "כלי נגינה ראשי") {

				this.validationMessage = "נא לבחור כלי נגינה ראשי";
			}
			else if (this.emailInput === "") {
				this.validationMessage = "נא להכניס אימייל"
			}
			else if (this.validateEmail() != 0) {
				this.validationMessage = "כתובת האימייל שהוקלדה אינה חוקית"
			}
			else if (this.phoneInput === "") {
				this.validationMessage = "נא להכניס מספר נייד"
			}
			else if (this.phoneInput.length != 10) {
				this.validationMessage = "מספר הנייד צריך להכיל 10 ספרות"
			}
			else {
				this.validationMessage = ""
			}
			this.$forceUpdate();
		}


	}

}
</script>



// WEBPACK FOOTER //
// TalkToMe.vue?2e744db2